{
  "manager": {
    "attendanceAddPersonSidebar": {
      "title": "Create Signup",
      "registrationOpportunity": "Registration Opportunity",
      "personType": "Person Type",
      "findUser": "Find a User",
      "searchPlaceholder": "Search by name or email",
      "submit": "Create Signup"
    },
    "attendanceSheetCreateSidebar": {
      "title": "Create Attendance Sheet",
      "program": "Program",
      "registrationOpportunities": "Registration Opportunities",
      "selectOpportunitiesPlaceholder": "Select registration opportunities...",
      "noOpportunitiesAvailable": "No registration opportunities available for this program.",
      "date": "Date",
      "createSheet": "Create Sheet"
    },
    "attendanceSheetIndex": {
      "title": "Attendance Sheets",
      "createSheet": "Create Attendance Sheet",
      "exporting": "Exporting...",
      "exportSelected": "Export Selected"
    },
    "attendanceSheetShow": {
      "notFoundTitle": "Attendance Sheet Not Found",
      "notFoundMessage": "The attendance sheet you're looking for doesn't exist or may have been deleted.",
      "attendanceRecords": "Attendance Records",
      "createSignup": "Create Signup",
      "noRecordsYet": "No attendance records yet.",
      "legend": "Legend:",
      "setStatus": "Set Status",
      "addNotesPlaceholder": "Add notes...",
      "saving": "Saving...",
      "saveNote": "Save Note",
      "recordCountSingular": "{count} record",
      "recordCountPlural": "{count} records"
    }
  }
}
